
import { Link, useNavigate } from "react-router-dom";
import { BarChart3, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { UserMenu } from "./user-menu";
import { useLanguage } from "@/contexts/language-context";

interface DesktopNavProps {
  isLoggedIn: boolean;
  userEmail: string | null;
  isAdmin: boolean;
  handleLogout: () => Promise<void>;
  invitesCount: number;
  isGuardian?: boolean;
  pendingRsvpCount?: number;
  hasTeams?: boolean;
  isParentView?: boolean;
  isDualRole?: boolean;
  managementRoleLabel?: string;
}

export function DesktopNav({ 
  isLoggedIn, 
  userEmail, 
  isAdmin, 
  handleLogout,
  invitesCount = 0,
  isGuardian = false,
  pendingRsvpCount = 0,
  hasTeams = true,
  isParentView = false,
  isDualRole = false,
  managementRoleLabel = "Coach",
}: DesktopNavProps) {
  const navigate = useNavigate();
  const { t } = useLanguage();
  
  return (
    <nav className="hidden md:flex items-center space-x-6">
      <Link 
        to="/" 
        className="text-foreground/80 hover:text-foreground transition-colors"
      >
        {t('navigation.home')}
      </Link>
      {isLoggedIn && (
        <>
          {hasTeams && (
            <>
              <Link 
                to="/dashboard" 
                className="text-foreground/80 hover:text-foreground transition-colors"
              >
                {t('navigation.dashboard')}
              </Link>
              <Link 
                to="/teams" 
                className="text-foreground/80 hover:text-foreground transition-colors"
              >
                {t('navigation.teams')}
              </Link>
              <Link 
                to="/create" 
                className="text-foreground/80 hover:text-foreground transition-colors"
              >
                {t('navigation.createPoll')}
              </Link>
            </>
          )}
          {isGuardian && (
            <Link 
              to="/parent" 
              className="text-foreground/80 hover:text-foreground transition-colors flex items-center gap-1 relative"
            >
              <Heart className="h-4 w-4" />
              <span>{t('navigation.parent')}</span>
              {pendingRsvpCount > 0 && (
                <Badge 
                  variant="destructive" 
                  className="h-5 min-w-5 p-0 text-[10px] flex items-center justify-center rounded-full absolute -top-2 -end-2"
                >
                  {pendingRsvpCount}
                </Badge>
              )}
            </Link>
          )}
          {isAdmin && !isParentView && (
            <Link 
              to="/stats" 
              className="text-foreground/80 hover:text-foreground transition-colors flex items-center gap-1 relative"
            >
              <BarChart3 className="h-4 w-4" />
              <span>Platform</span>
            </Link>
          )}
        </>
      )}
      
      {isLoggedIn ? (
        <UserMenu userEmail={userEmail} handleLogout={handleLogout} isParentView={isParentView} isDualRole={isDualRole} managementRoleLabel={managementRoleLabel} hasTeams={hasTeams} />
      ) : (
        <Button 
          variant="default" 
          size="sm" 
          onClick={() => navigate("/login")}
        >
          {t('navigation.login')}
        </Button>
      )}
    </nav>
  );
}
